import "core-js/modules/es.number.constructor.js";
import { reactive, computed, ref } from "vue";
import { fallbackAvatar } from "../utils/avatar";
import markdownIt from "../utils/markdown-it";
import { getUserInfo } from "../utils/storage";
export default {
  name: "KilaKilaCommentItem",
  props: {
    comment: {
      type: Object,
      require: true
    },
    floorNumber: {
      type: Number,
      require: true
    }
  },
  emits: ["reply", "update", "delete"],
  setup: function setup(props, context) {
    var commentClass = reactive(["comment-item"]);

    if (props.comment.isAdmin) {
      commentClass.push("comment-item-admin");
    }

    var content = computed(function () {
      return markdownIt.render(props.comment.content);
    });
    var moreActionsMenu = ref();
    var userInfo = getUserInfo();
    var canModify = userInfo ? ref(userInfo.isAdmin || props.comment.createBy == userInfo.id) : ref(false);

    function scrollToAnchor(event) {
      event.target.scrollIntoView({
        behavior: "smooth"
      });
    }

    function showMoreActionsMenu() {
      moreActionsMenu.value.handleOpen();
    }

    function handleMenuCommand(command) {
      context.emit(command, props.comment);
    }

    return {
      commentClass: commentClass,
      content: content,
      moreActionsMenu: moreActionsMenu,
      canModify: canModify,
      scrollToAnchor: scrollToAnchor,
      showMoreActionsMenu: showMoreActionsMenu,
      handleMenuCommand: handleMenuCommand
    };
  }
};